export default __webpack_public_path__ + "static/media/cakephp.3b00d8c3.svg";